import { AppState } from '../reducers'
import { MODAL_STATE_KEY } from './constants'

export const getModalState = (state: AppState) => state[MODAL_STATE_KEY]
export const getModalById = (state: AppState, id: string) => getModalState(state).byId[id]
export const getAllModals = (state: AppState) => getModalState(state).list.map(id => getModalById(state, id))
